import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu-desplegable',
  templateUrl: './menu-desplegable.component.html',
  styles: [
  ]
})
export class MenuDesplegableComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
